import axios from "@/utils/request"

function TEMPLATE_RECYCLIE_LIST(params) {
    return axios.get("/kshAdmin/TemplateRecycle/index", {
        params: params
    })
}
function TEMPLATE_RECYCLIE_RECOVERY(params) {
    return  axios.post("/kshAdmin/TemplateRecycle/recovery",{
       ...params
    })
}
function DELE(params) {
    return  axios.post("/kshAdmin/TemplateRecycle/delete",{
        ids: params
    })
}

export default {
    TEMPLATE_RECYCLIE_LIST,
    TEMPLATE_RECYCLIE_RECOVERY,
    DELE
}
